import { ContentItem } from '@kentico/kontent-delivery';
import { get } from 'lodash';
import { IAboutUsProps } from './../components/about-us/about-us';
import { IAboutUs } from './../typings/kentico.d';

export class AboutUsModel extends ContentItem {
  get title(): string {
    return get(this._config, 'elements.title.value', 'no title');
  }

  get description(): string {
    return get(this._config, 'elements.description.value', 'no description');
  }
  public static create(data: IAboutUs): IAboutUsProps {
    const { title, description } = new AboutUsModel(data);

    return {
      title,
      description
    };
  }
}
